// PostModal.jsx

import React from 'react';
import PropTypes from 'prop-types';
import './PostModal.css';

const PostModal = ({ title, chartTitle,chartSubTitle, source, sourceLink, image, onClose, className }) => {
  return (
    <div className={className} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <span className="close-btn" onClick={onClose}>&times;</span>
        <img src={image} alt={title} />
        <h1>{title}</h1>
        <p><b>{chartTitle}: </b>{chartSubTitle}</p>
        <p><b>Original chart and data source:{'\t'}</b>
            <a href={sourceLink} target="_blank"  rel="noreferrer">
                {source}
            </a>
        </p>
      </div>
    </div>
  );
};

PostModal.propTypes = {
  title: PropTypes.string.isRequired,
  chartTitle: PropTypes.string.isRequired,
  chartSubTitle: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  sourceLink: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PostModal;
